/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable max-len */
import React, {
    useEffect, useState, useCallback, useContext, useRef,
} from 'react';
import { ThreeDots } from 'react-loader-spinner';
import { distributorService } from '../../service/distributor.service';
import Pagination from '../../Components/Pagination';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import IPOrderReportSkeleton from './ipOrderReportSkeleton';
import IPOrderFilterModal from './FilterModal';
import HeaderContext from '../../Components/Context/HeaderContext';

import { PriceHandler } from '../../redux/helper/CamelCase';

function IPOrderReport() {
    const { SetSuccessMessage, SetErrorMessage, setcolorValue } = useContext(HeaderContext);

    const [reportList, setReportList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setAlldata] = useState({});
    const [loading, setLoading] = useState(true);
    const [filterModal, setFilterModal] = useState(false);
    const [emptyData, setEmptyData] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [selected, setselected] = useState({ start_date: '', end_date: '' });
    const [Filter, setFilter] = useState({ date_range: [], customer_code: [] });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [exportLoading, setExportLoading] = useState(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setLoading(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setLoading(true);
    }, [currentPage]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (buttonRef.current && !buttonRef.current.contains(event.target)) {
                setexportClick(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [buttonRef]);

    const fetchReportList = useCallback((() => {
        distributorService.IPOrderReportList(currentPage, debouncedSearch, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                const items = response.data.Items || [];
                if (items.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setReportList(items);
                setAlldata(response);
                setCurrentPage(response.data.current_page || currentPage);
                setTotalPage(response.data.number_of_pages || 1);
            } else {
                setLoading(false);
                setAlldata([]);
            }
        });
    }), [currentPage, debouncedSearch, filterValue]);

    const handlePageClick = async (data) => {
        setLoading(true);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handleIPOrderReports = () => {
        setLoading(true);
        setCurrentPage(1);
        setfilterValue('');
    };

    const handleExport = useCallback((() => {
        distributorService.IPOrderReportList(currentPage, debouncedSearch, filterValue, exportSelected).then((val) => {
            if (val.data.success_status) {
                SetSuccessMessage(val.data.message);
                setcolorValue(false);
                setexportClick(false);
                setexportSelected('');
                setExportLoading(null);
                window.open(val.data.url, '_blank');
                setTimeout(() => { SetSuccessMessage(''); }, 2000);
            } else {
                SetErrorMessage(val.data?.message || 'Export failed. Please try again.');
                setcolorValue(true);
                setExportLoading(null);
                setTimeout(() => { SetErrorMessage(''); setcolorValue(false); }, 3000);
            }
        }).catch(() => {
            SetErrorMessage('Export failed. Please try again.');
            setcolorValue(true);
            setExportLoading(null);
            setTimeout(() => { SetErrorMessage(''); setcolorValue(false); }, 3000);
        });
    }), [exportSelected]);

    function isExceedingSixMonths(date1, date2) {
        const startDate = new Date(date1);
        const endDate = new Date(date2);
        const daysDiff = (endDate - startDate) / (1000 * 60 * 60 * 24);
        return daysDiff > 183;
    }

    const handleExportClick = (exportType) => {
        setExportLoading(exportType);
        setexportClick(false);
        setexportSelected(exportType);
    };

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        fetchReportList();
    }, [fetchReportList]);

    return (
        <div className="py-6 pr-[18px] main-screen">
            <div className="flex justify-between pb-[18px]">
                <h5 className="text-xs4 font-semibold text-[#555259]">IP-Based Order Report</h5>
                <div className="flex">
                    <div className="relative">
                        <label htmlFor="ip-search" />
                        <input
                            type="text"
                            name="ip-search"
                            id="ip-search"
                            data-testid="ip-report-search"
                            className="w-[235px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e.target.value);
                            }}
                            autoComplete="off"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px]" />
                    </div>
                    <div className="pl-2">
                        <button
                            type="button"
                            data-testid="filter-btn"
                            className="h-[35px] text-xs2 font-semibold text-[#555259] px-6 border border-[#555259] rounded-lg"
                            onClick={() => setFilterModal(true)}
                        >
                            Filter
                        </button>
                    </div>
                    <div className="pl-2 dropdown relative" ref={buttonRef}>
                        <button
                            type="button"
                            data-testid="export-btn"
                            disabled={reportList.length === 0 || emptyData || loading}
                            className={`dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg flex items-center justify-center ${reportList.length === 0 || emptyData || loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                            onClick={() => {
                                if (!filterValue.includes('date_range')) {
                                    SetErrorMessage('Please select a date range to export');
                                    setcolorValue('warning');
                                    setTimeout(() => { SetErrorMessage(''); setcolorValue(false); }, 2000);
                                    return;
                                }
                                if (isExceedingSixMonths(selected?.start_date, selected?.end_date)) {
                                    SetErrorMessage('Date range should not exceed 6 months');
                                    setcolorValue(true);
                                    setTimeout(() => { SetErrorMessage(''); setcolorValue(false); }, 2000);
                                    return;
                                }
                                setexportClick(!exportClick);
                            }}
                        >
                            {exportLoading ? <ThreeDots width={30} height={24} /> : 'Export'}
                        </button>
                        <ul className={`dropdown-menu min-w-[111px] absolute ${exportClick ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`}>
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    data-testid="csv-btn"
                                    className={`dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 ${exportLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
                                    href="#"
                                    onClick={(e) => { e.preventDefault(); if (!exportLoading) handleExportClick('csv'); }}
                                >
                                    CSV
                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    data-testid="pdf-btn"
                                    className={`dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 ${exportLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
                                    href="#"
                                    onClick={(e) => { e.preventDefault(); if (!exportLoading) handleExportClick('pdf'); }}
                                >
                                    PDF
                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    data-testid="excel-btn"
                                    className={`dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 ${exportLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
                                    href="#"
                                    onClick={(e) => { e.preventDefault(); if (!exportLoading) handleExportClick('excel'); }}
                                >
                                    Excel
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {loading ? <IPOrderReportSkeleton /> : (
                <div>
                    {reportList.length > 0 && (
                        <div
                            className="overflow-auto dropdown-menu pb-7 relative z-10"
                            style={{ height: 'calc(100vh - 298px)' }}
                        >
                            <table className="w-full table-auto relative">
                                <thead className="sticky top-0 left-0 z-[2]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[160px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                            <span className="text-xs5 font-bold text-[#FFFFFF]">Order No.</span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-6 min-w-[148px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">Order Date</span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-6 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">Distributor Name</span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-6 min-w-[160px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">Distributor Code</span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-6 min-w-[148px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">Order Value</span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-6 min-w-[160px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">IP Address</span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-6 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">Host Name</span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-6 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">Order Acceptance No.</span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-6 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">Order Acceptance Date</span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-6 min-w-[160px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">Invoice Number</span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-6 min-w-[148px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">Invoice Date</span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-6 min-w-[170px] rounded-br-lg rounded-tr-lg bg-[#555259]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center whitespace-nowrap">Product Category</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportList.map((item, i) => (
                                        <tr key={item.order_number} data-testid={`ip-report-row-${i}`} className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                            <td
                                                data-testid={`order-number-${i}`}
                                                className="text-sm font-normal text-[#090406] py-2.5 px-6 sticky left-0"
                                                style={{ background: 'rgba(255, 255, 255, 0.45)', backdropFilter: 'blur(5.5px)' }}
                                            >
                                                {item?.order_number || '-'}
                                            </td>
                                            <td data-testid={`order-date-${i}`} className="text-sm font-normal text-[#090406] py-2.5 px-6 text-center">
                                                {item?.order_date || '-'}
                                            </td>
                                            <td data-testid={`distributor-name-${i}`} className="text-sm font-normal text-[#090406] py-2.5 px-6">
                                                {item?.distributor_company_name || '-'}
                                            </td>
                                            <td data-testid={`distributor-code-${i}`} className="text-sm font-normal text-[#090406] py-2.5 px-6 text-center">
                                                {item?.distributor_id || '-'}
                                            </td>
                                            <td data-testid={`order-value-${i}`} className="text-sm font-normal text-[#090406] py-2.5 px-6 text-center">
                                                {item?.total_price != null ? PriceHandler(item.total_price) : '-'}
                                            </td>
                                            <td data-testid={`ip-address-${i}`} className="text-sm font-normal text-[#090406] py-2.5 px-6 text-center">
                                                {item?.source_ip || 'Not Available'}
                                            </td>
                                            <td data-testid={`host-name-${i}`} className="text-sm font-normal text-[#090406] py-2.5 px-6 text-center">
                                                {item?.host_name || 'Not Available'}
                                            </td>
                                            <td data-testid={`acceptance-number-${i}`} className="text-sm font-normal text-[#090406] py-2.5 px-6 text-center">
                                                {item?.order_acceptance_number || '-'}
                                            </td>
                                            <td data-testid={`acceptance-date-${i}`} className="text-sm font-normal text-[#090406] py-2.5 px-6 text-center">
                                                {item?.order_acceptance_date || '-'}
                                            </td>
                                            <td data-testid={`invoice-number-${i}`} className="text-sm font-normal text-[#090406] py-2.5 px-6 text-center">
                                                {item?.invoice_number || '-'}
                                            </td>
                                            <td data-testid={`invoice-date-${i}`} className="text-sm font-normal text-[#090406] py-2.5 px-6 text-center">
                                                {item?.invoice_date || '-'}
                                            </td>
                                            <td data-testid={`product-category-${i}`} className="text-sm font-normal text-[#090406] py-2.5 px-6 text-center">
                                                {item?.product_category || item?.order_category || '-'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {!loading && reportList.length > 0 && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            totalPage={totalPage}
                            List={alldata}
                            currentPage={currentPage}
                        />
                    )}

                    {filterModal && (
                        <IPOrderFilterModal
                            filterModal={filterModal}
                            setFilterModal={setFilterModal}
                            Filter={Filter}
                            setFilter={setFilter}
                            filterValue={filterValue}
                            setfilterValue={setfilterValue}
                            handleFilter={handleFilter}
                            handleIPOrderReports={handleIPOrderReports}
                            selected={selected}
                            setselected={setselected}
                            SetSuccessMessage={SetSuccessMessage}
                        />
                    )}
                </div>
            )}

            {!loading && emptyData && (
                <EmptyScreen
                    search="yes"
                    text="no IP-Based Order Report"
                    buttonRequired={false}
                    all={searchValue.length > 0 ? 'under searched term' : 'found'}
                />
            )}
        </div>
    );
}

export default IPOrderReport;
